import React from 'react';
import WrappedBase from './WrappedBase';

import QuickShopModal from '../containers/QuickShopModal';

export default class QuickShopModalWrapped extends React.Component {
  render() {
    return (
      <WrappedBase>
        <QuickShopModal {...this.props} />
      </WrappedBase>
    );
  }
}
